// Angular
import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// RxJS
// State
// Services and Models
import { User } from '../../../../../core/auth';

@Component({
  selector: 'kt-user-edit-dialog',
  templateUrl: './user-view-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UserViewDialogComponent implements OnInit {
  user: User;
  viewLoading = false;
  photoURL = '/assets/media/users/blank.jpg';

  constructor(
    public dialogRef: MatDialogRef<UserViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.user = this.data?.user;
    if (this.user?.profileUrl !== '') {
      this.photoURL = this.user.profileUrl;
    }
  }

  getItemCssClassByStatus(status: boolean): string {
    switch (status) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
    return '';
  }

  getItemStatusString(status: boolean): string {
    switch (status) {
      case false:
        return 'inActive';
      case true:
        return 'Active';
      default:
        return '';
    }
  }
}
